<template>
    <div class="py-3 create-user-main-container">
        <div class="d-flex mb-3 title-container">
            <img src="../../../assets/images/title-icon.png" alt="">
            <h3 class="h3">Create Team</h3>
        </div>
        
    
        <div id="createUserContainer" class="tabcontent-create-user">
            <form class="form-container row d-flex flex-column justify-content-between">
                <div class="row col-12 inputs-container">
                    <div class="col-md-6">
                        <label class="form-label">Select Entity <span style="color: #E95626">*</span></label>
                        <Multiselect
                                class="designOfAssign"
                                v-model="entity"
                                :options="teams"
                                placeholder="Choose Entity"
                                @change="entityChangeHandler"
                        />
                        <div class="err " v-if="errors['entity'].length > 0">
                            <div v-for="msg in errors['entity']" class="text-danger">{{msg}}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Select Team Leader <span style="color: #E95626">*</span></label>
                        <Multiselect
                                class="designOfAssign"
                                v-model="leader"
                                :options="options"
                                placeholder="Choose Leader"
                                @change="selectTeamLeader"
                                ref="multiselectLeader"
                        />
                        <div class="err" v-if="errors['leader'].length > 0">
                            <div v-for="msg in errors['leader']" class="text-danger">{{msg}}</div>
                        </div>
                        <div class="text-danger" v-if="isCorrect">{{errorMessageSelected2}}</div>
                    </div>
                </div>
                <div class="row cssDesignRole col-12">
                    <div class="w-100">
                        <label class="form-label">Select Users</label>
                        <Multiselect
                                    class="designOfAssign"
                                    v-model="value"
                                    :options="options"
                                    placeholder="Choose Users"
                                    ref="multiselect"
                                    mode="tags"
                                    :close-on-select="false"
                                    :searchable="true"
                                    :create-option="true"
                                    @change="selectTeamMember"
                        />
                        <div class="text-danger" v-if="isCorrect">{{errorMessageSelected1}}</div>
                        <div v-if="errors['users'].length > 0">
                            <div v-for="msg in errors['users']" class="text-danger">{{msg}}</div>
                        </div>
                    </div>
                </div>

                <div class="row col-md-12 cssGap">
                    <div class="hrAll">
                        <hr class="new1 col-md-6">
                        &nbsp;&nbsp;&nbsp;
                        <span>OR</span>
                        &nbsp;&nbsp;&nbsp;
                        <hr class="new2 col-md-6">
                    </div>


                    <div class="col-md-6">
                        <label>Upload User List</label>
                        <div class="upload-file2" ref="uploadFilePond">
                            <FilePondDemo @fileRemove="fileRemove" @fileUpload="fileUpload"
                                        accepted="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv" :allowMultiple="false"
                                        content='<div class=""><svg xmlns="http://www.w3.org/2000/svg" width="40" height="53.751" viewBox="0 0 53.326 53.751">
                                    <path id="Icon_awesome-file-import" data-name="Icon awesome-file-import" d="M1.666,30.235A1.678,1.678,0,0,0,0,31.915v3.359a1.678,1.678,0,0,0,1.666,1.68H13.332V30.235ZM52.6,11.023,42.4.735A2.488,2.488,0,0,0,40.63,0h-.635V13.438H53.326V12.8A2.522,2.522,0,0,0,52.6,11.023ZM36.662,14.278V0H15.831a2.5,2.5,0,0,0-2.5,2.52V30.235H26.663V23.39A1.669,1.669,0,0,1,29.517,22.2l9.957,10.131a1.8,1.8,0,0,1,0,2.52l-9.967,10.12a1.669,1.669,0,0,1-2.854-1.186V36.954H13.332V51.231a2.5,2.5,0,0,0,2.5,2.52h35a2.5,2.5,0,0,0,2.5-2.52V16.8H39.161A2.517,2.517,0,0,1,36.662,14.278Z" fill="#e95626"/>
                                </svg>
                                <div class="my-3">Drag & Drop Users File Here</div></div>' />
                        </div>
                    </div>

                    <div class="col-md-6 checkPositionRelative">
                        <label>Download template of users, fill it, and upload to your list</label>
                        <div class="upload-file pt-4">
                            <div class="imgNew" @click.prevent="viewDocumentHandler" style="cursor: pointer;">
                                <img src="../../../assets/images/downloadExcel.png" alt=""> &nbsp;&nbsp; <span style="color: #e95626;position:relative;top:3px;">Download Excel Template</span>
                            </div>
                        </div>
                    </div>


                </div>
            </form>
            <div v-if="errorMessages.length > 0" class="error-container">
                <div v-for="msg in errorMessages" class="text-danger my-4">{{msg}}</div>
            </div>
        </div>
        <div class="save-button-container">
            <router-link class="back-route" ref="backBtn" @click="backHandler" :to="this.isDataFlag ? '#':'/settings/teams'">
                <button class="save-button back-btn">Back</button>
            </router-link>
            <button class="save-button" @click.prevent="saveTeam" ref="buttonSave">Save</button>
        </div>
    </div>
    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import team from "../../../api-services/team";
    import Multiselect from '@vueform/multiselect';
    import FilePondDemo from '../../components/FilePondDemo';
    import SaveBtn from '../../components/SaveBtn';
    import ConfirmationModal from '../../components/ConfirmationModal';
    import AlartModal from "../../components/AlartModal";
    import changeHandler from '../../../validation/teamValidation';
    import readXlsxFile from 'read-excel-file';
    import {computed} from "vue";
    import repository from "../../../api-services/repository";

    export default {
        name: 'setting-entity-create',
        components: {
            Multiselect,
            FilePondDemo,
            AlartModal,
            SaveBtn,
            ConfirmationModal
        },
        data() {
            return {
                changeHandler,
                teams: [],
                originalTeams:[],
                entity: '',
                error: null,
                isDownloaded:false,
                isFull: false,
                isCorrect:false,
                errorMessageSelected1:null,
                errorMessageSelected2:null,
                value: [],
                leader:null,
                options: [],
                errors: {
                    entity: [],
                    users: [],
                    leader:[],
                    isError: false
                },
                ImagePath:'',
                showModal: false,
                message: null,
                errorMessage: null,
                errorMessages: [],
                responseErrorMessage: '',
                showErrorModal: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    users: false,
                    leader:false,
                    entity: false,
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage),
                checkDomain:null,
                usersAvailableInSystem:[],
            }
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'settings');
            this.getTeams();
            // this.getUsers();
            this.$refs.uploadFilePond.style.opacity = '0.5';
            this.$refs.uploadFilePond.style.pointerEvents = 'none';
            this.checkDomain = Object.keys(this.$store.state.auth.user.data.organization).length > 0 ? this.$store.state.auth.user.data.organization.domain : this.$store.state.auth.user.data.email.split('@')[1];
        },
        methods: {
            async viewDocumentHandler(e,filePath){
                const link = document.createElement("a");
                link.href = "https://dk703uarlyapi.cloudfront.net/users-demo.xlsx";
                link.download = "users_demo.xlsx";
                link.click();
                // setTimeout(() => {
                    if(!this.isDownloaded){
                        this.$refs.uploadFilePond.style.opacity = '1';
                        this.$refs.uploadFilePond.style.pointerEvents = 'auto';

                    }
                // } , 3000);
            },
            async confirmModalHandler  (event)  {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/settings/teams');
                }
            },
            entityChangeHandler(e){
                this.errors['entity'][0] = '';
                this.errors.isError = false;
                if (this.entity){
                    this.isData.entity = true
                }else{
                    this.isData.entity = false
                }

                if ( this.isData.entity ||  this.isData.users) {
                    this.$store.dispatch('setDataFlag', true);
                    // console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    // console.log('no data ==>> ')
                }
            },
            async backHandler() {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if (setDataFlag) {
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                } else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            selectTeamMember(e){
                if(this.leader != null){
                    if(e.includes(this.leader)){
                        // this.$refs.buttonSave.disabled = true;
                        this.$refs.multiselectLeader.deselect({value:e});
                        // this.isCorrect = true;
                        // this.errorMessageSelected1 = "Please Check Team Leader In Members";

                    }else{
                        this.$refs.buttonSave.style.display = "block";
                        // this.$refs.buttonSave.disabled = false;
                        this.isCorrect = false;
                        // this.errorMessageSelected1 = "";
                    }
                }else{
                    // console.log('no similar');
                }

            },
            selectTeamLeader(e){
                this.errors['leader'][0] = '';
                this.errors.isError = false;
                if(this.value.length > 0){
                    if(this.value.includes(e)){
                        // this.$refs.buttonSave.style.display = "none";
                        this.$refs.multiselect.deselect({value:e});
                        // this.isCorrect = true;
                        // this.errorMessageSelected1 = e+" is Team Leader";
                    }else{
                        this.$refs.buttonSave.style.display = "block";
                        this.isCorrect = false;
                        // this.errorMessageSelected1 = "";
                    }
                }else{
                    // console.log('no similar');
                }

            },
            getTeams: async function () {
                try {
                    const response = await team.index(false, 'asc',false);
                    // console.log(response);
                    this.originalTeams = response.data.teams;
                    for(let o = 0 ; o < this.originalTeams.length ; o++){
                        if(this.originalTeams[o].users_count == 0){
                            this.teams.push({label: this.originalTeams[o].name, value:this.originalTeams[o].id});
                        }
                    }


                    this.usersAvailableInSystem = response.data.availableUsers;
                    for (let i = 0; i < response.data.availableUsers.length; i++) {
                        this.options.push({
                            value: response.data.availableUsers[i].email,
                            label: response.data.availableUsers[i].name
                        });
                    }

                } catch (e) {
                    // console.log(e);
                    this.error = e;
                }
            },
            async fileRemove(){
                this.value = [];
                this.options = [];
                for (let i = 0; i < this.usersAvailableInSystem.length; i++) {
                    this.options.push({
                        value: this.usersAvailableInSystem[i].email,
                        label: this.usersAvailableInSystem[i].name
                    });
                }
            },
            getUsers: async function () {
                try {
                    const response = await team.index(false,'asc',false);
                    this.usersAvailableInSystem = response.data.availableUsers;
                    for (let i = 0; i < response.data.availableUsers.length; i++) {
                        this.options.push({
                            value: response.data.availableUsers[i].email,
                            label: response.data.availableUsers[i].name
                        });
                    }

                } catch (e) {
                    // console.log(e);
                    this.error = e;
                }
            },
            async fileUpload(e) {

                // console.log({e});
                let newData = [];
                let usersAvailable = [];
                let usersInExcel = [];
                let usersNotInTeams;


                const response = await team.index('users');
                // for (let i = 0; i < response.data.availableUsers.length; i++) {
                //     usersAvailable.push({value:response.data.availableUsers[i].email , label: response.data.availableUsers[i].name});
                // }

                await readXlsxFile(e['file']).then((data) => {
                    data.shift();
                    newData.push(data);
                });

                newData[0].forEach(item => {
                    usersInExcel.push({value: item[1], label: item[0]});
                });

                // console.log(this.usersAvailableInSystem);
                console.log(usersInExcel);
                usersAvailable = usersAvailable.concat(usersInExcel);
                console.log(usersAvailable);


                if(usersAvailable.length > 0){
                    usersAvailable.forEach(item => {
                        let domainFile = item['value'];
                        let dominOrigin = domainFile.split("@");

                        let res1 = /\S+@\S+\.\S+/.test(item['value']);
                        let res2 = /^[a-zA-Z()_ \-\[\]'\\|,.\/]*$/.test(item['label']);
                        if (!res1 || !res2) {
                            this.showModal = true;
                            this.ImagePath = 'close.png';
                            this.message = 'Please Check Excel Emails Or Names';
                            this.$refs.multiselect.remove();
                        }else if(this.checkDomain !== dominOrigin[1]){
                            this.showModal = true;
                            this.ImagePath = 'close.png';
                            this.message = 'Please Check Excel Emails Domain';
                            this.$refs.multiselect.remove();
                        }else{
                            this.options.push({value: item['value'] , label: item['label']});
                        }
                    });
                }else{
                    this.showModal = true;
                    this.ImagePath = 'close.png';
                    this.message = 'No Users Available To Assign To Teams';
                }


               if(usersAvailable.length > 0){
                   this.isData.users = true;
               }else{
                   this.isData.users = false;
               }

                if ( this.isData.entity ||  this.isData.users) {
                    this.$store.dispatch('setDataFlag', true);
                    // console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    // console.log('no data ==>> ')
                }

                this.$refs.multiselect.$el.focus();
                this.$refs.multiselect.selectAll();

            },

            saveTeam: async function () {
                try {
                    if (this.entity === '' || this.entity === null) {
                        this.errors.isError = true;
                        this.errors['entity'][0] = '*Required';
                    }

                    if (this.leader === null || this.leader === null) {
                        this.errors.isError = true;
                        this.errors['leader'][0] = '*Required';
                    }


                    if (!this.errors.isError) {
                        const response = await team.create(this.entity, {users: this.value,leader:this.leader});

                        if (response.status === 200) {
                            this.showModal = true;
                            this.ImagePath = 'okImage.svg';
                            this.message = response.data.message;
                            this.$store.dispatch('setDataFlag', false);
                            setTimeout(() => {
                                this.$router.push({name: 'entity'});
                            }, 1000);
                        } else {
                            console.log('Something Wrong !');
                        }
                    }


                } catch (e) {
                    if (e.response.data.errors) {
                        if (e.response.data.errors.users) {
                            if (e.response.data.errors.users)
                                e.response.data.errors.users.forEach((err, idx) => {
                                    this.errors['users'][idx] = `* ${err}`
                                });
                        }  else {
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                let record = property.split('.')[0];
                                this.errors['users'][idx++] = `* record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                            }
                        }
                    } else if (e.response.data) {
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = e.response.data.message;
                    }
                }
            }
        }
    }
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>

.back-btn{
    background-color: #707070 !important;
}
.title-container{
    align-items: center;
    margin-bottom: 2% !important;
}
.title-container img{
    margin-bottom:0;
    padding-right: 10px;
}

.text-danger{
    font-size: 13px;
}
.create-user-main-container{
    padding-inline: 40px;
}

.title-container .h3{
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom:0;
    font-size: calc(1rem+0.5vw);
}
.tabcontent-create-user{
    height: 65vh;
    overflow-y: auto;
    overflow-x:hidden;
}
#createUserContainer{
    border: 1px solid var(--table-color-data);
    background-color: var(--table-color-data);
    padding: 23px 0 23px 23px !important;
    border-radius: 15px;
}
label{
        font-weight: 600;
}
input,
input::placeholder,
.designOfAssign,
.designOfAssign :deep(.multiselect-placeholder)
{
    background-color: var(--input-background);
    color: var(--input-color) !important;
    font-weight: normal;
    font-size: 13px;
    font-style: italic;
    opacity:1 !important;
}
.input-group-text {
    margin-left: 10px;
    height: 38px;
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    font-size: 12px;
}

.cssGap {
    gap: 0;
}

/* .cssDesignRole {
    position: relative;
    right: 16px;
} */

.hrAll {
    display: flex;
    width: 97%;
}

.textH5 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.designOfAssign {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    
    width: 100%;
}

.err {
    overflow-y: auto;
    min-height: 30px;
    max-height: 170px;
}

.custom-input,
.custom-input:focus,
.form-control {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
}
.multiselect-caret{
    background-color: #848484 !important;
}




.upload-file {
    background-color: var(--input-background);
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
    display: flex;
}

.upload-file2 {
    background-color: var(--input-background);
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
    height: -webkit-fill-available;
    margin-bottom: 22px;
}

.form-container {
    gap: 20px;
}

.error-container {
    max-height: 250px;
    min-height: 10px;
    height: 90px;
    padding: 10px;
    margin-top: 40px;
    overflow-y: auto;
}

.inputs-container {
    height: 80px;
}
.save-button{
    border: none;
    color: #fff;
    background-color: var(--btn-bg-color);
    padding: 0px 50px;
    border-radius: 5px;
    font-weight: normal;
    font-size: 18px;
    height: 100%;
}
.back-route{
    margin-right: 10px;
    font-size: 18px;
}
.save-button-container{
    margin-top: 2vh;
    display: flex;
    justify-content: end;
    width: 100%;
    height: 35px;
}
</style>

